/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Card, IconButton, Box, Typography, Button, Checkbox,
} from "@mui/material";
import {checkUserAllowed, getImage, getLocalDate} from "helpers/utils";

import EditIcon from '@mui/icons-material/Edit';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import "./AdminSellerProduct.scss";
import HoverBox from "components/HoverBox";
import LazyImage from "components/LazyImage";
import {H2, H4, H5, H6} from "components/CustomTypography";
import {DATE_TIME_FORMAT_SHORT} from "config/constants";


const AdminSellerProduct = (props) => {

    const history = useHistory();

    const handlePage = (page) => (e) => {
        history.push(page);
    };

    const {
    product, editProductStatus, editProductSetting, userDetails, isSelected, onSelectProduct,
  } = props;

    const handleProductsButtonClick = (product) => {
        history.push(`/products/${product.id}`);
    };

  return (
      <Box mb={2} sx={{ position: 'relative' }}>
          {/* Checkbox for selection */}
          {onSelectProduct && (
              <Box sx={{ position: 'absolute', top: 0, left: 0, zIndex: 10 }}>
                  <Checkbox
                      checked={isSelected || false}
                      onChange={onSelectProduct}
                      onClick={(e) => e.stopPropagation()}
                  />
              </Box>
          )}
          
          <HoverBox  mb={0} mx="auto" borderRadius="2px" onClick={checkUserAllowed(userDetails.userlevel, "viewproductdetail") && editProductSetting}>
              <LazyImage
                  src={getImage(product.images)}
                  width={150}
                  height={150}
                  alt={product.name}
                  mx="auto"
              />
          </HoverBox>
          <H2 sx={{ textTransform: "capitalize" }} fontSize={14} textAlign="left" title={product.name} ellipsis>
                  {product.name}
          </H2>
          <H6 textTransform="uppercase" fontSize={10} textAlign="left">
              {product.title}
          </H6>
          <H4 textAlign="left">
              {checkUserAllowed(userDetails.userlevel, "viewproductdetail") &&
                  <IconButton color="primary" size="small" onClick={editProductStatus}>
                      <MoreHorizIcon/>
                  </IconButton>
              }
              {checkUserAllowed(userDetails.userlevel, "approveproduct") &&
                  <IconButton color="primary" size="small" onClick={editProductSetting}>
                      <EditIcon/>
                  </IconButton>
              }
          </H4>
          <H2 fontSize={12} textAlign="left">
              {product.price} / {product.is_price_visible ? "Visible" : "Hidden"}
          </H2>
          <H5 fontSize={12} textAlign="left">
            Likes: {product.likes} / {product.is_verified ? "Approved" : "Unapproved"} / {product.is_listing_ready ? "Ready" : "NotReady"}
          </H5>
          <H5 fontSize={10} textAlign="left" ellipsis>
              {getLocalDate(product.created_at, DATE_TIME_FORMAT_SHORT)}
          </H5>
      </Box>

  );
};


export default AdminSellerProduct;
